/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Button, Form, Col, Row, LabeledValue } from 'components';
import { FormInstance } from 'antd';
import { SHOWING_PROVIDERS } from '@bb/domain/dist/types';
import { MemberNumberState } from '@bb/users';
import type { IContactSalesFormBody } from '@/app-package';
import { StyledInput, StyledSelect } from './common';

export type OnboardingContactSalesFormProps = {
  onSubmit?: (values: IContactSalesFormBody) => void;
  reason?: MemberNumberState;
  working?: boolean;
};

export const OnboardingContactSalesForm: React.FC<
  OnboardingContactSalesFormProps
> = ({ onSubmit, reason, working }) => {
  const [displayOthersInput, setDisplayOthersInput] = React.useState(false);

  const formRef = React.useRef<FormInstance<IContactSalesFormBody>>();

  const _handleFormOnFinish = (values: IContactSalesFormBody) => {
    if (!onSubmit) {
      return;
    }

    // @ts-ignore
    onSubmit({ ...values, reason });
  };

  const _handleValuesChange = (values: IContactSalesFormBody) => {
    if (values.currentProvider) {
      if (values.currentProvider === SHOWING_PROVIDERS.OTHER) {
        setDisplayOthersInput(true);
      } else {
        setDisplayOthersInput(false);
        formRef.current.resetFields(['otherProvider']);
      }
    }
  };

  const PROVIDER_OPTIONS: LabeledValue[] = Object.values(SHOWING_PROVIDERS).map(
    provider => ({ label: provider, value: provider }),
  );

  return (
    <Form
      ref={formRef}
      name="agentRequestOnboardingForm"
      onFinish={_handleFormOnFinish}
      onValuesChange={_handleValuesChange}
    >
      <StyledInput.Group>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="firstName"
              rules={[
                { required: true, message: 'Please enter your first name' },
              ]}
            >
              <StyledInput placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="lastName"
              rules={[
                { required: true, message: 'Please enter your last name' },
              ]}
            >
              <StyledInput placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>
      </StyledInput.Group>
      <Form.Item
        name="email"
        rules={[
          {
            type: 'email',
            required: true,
            message: 'Please enter a valid email',
          },
        ]}
      >
        <StyledInput placeholder="E-mail" />
      </Form.Item>
      <StyledInput.Group>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="mobilePhone"
              rules={[
                { required: true, message: 'Please enter your mobile number' },
              ]}
            >
              <StyledInput placeholder="Mobile Number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="officePhone"
              rules={[
                { required: true, message: 'Please enter your office number' },
              ]}
            >
              <StyledInput placeholder="Office Number" />
            </Form.Item>
          </Col>
        </Row>
      </StyledInput.Group>
      <Form.Item name="brokerageName">
        <StyledInput placeholder="Brokerage Name" />
      </Form.Item>
      <StyledInput.Group>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item name="title">
              <StyledInput placeholder="Title" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="agentCount">
              <StyledInput placeholder="Number of Agents" />
            </Form.Item>
          </Col>
        </Row>
      </StyledInput.Group>
      <Form.Item name="currentBoards">
        <StyledInput placeholder="What boards are you a part of?" />
      </Form.Item>
      <Form.Item
        name="currentProvider"
        id="AgentRequestOnboardingForm_current_provider"
      >
        <StyledSelect
          allowClear
          placeholder="Select existing provider"
          options={PROVIDER_OPTIONS}
        />
      </Form.Item>

      {displayOthersInput && (
        <Form.Item name="otherProvider">
          <StyledInput placeholder="Provider Name" />
        </Form.Item>
      )}

      <Form.Item>
        <Button block type="primary" htmlType="submit" disabled={working}>
          Contact Sales
        </Button>
      </Form.Item>
    </Form>
  );
};
